export default __webpack_public_path__ + "media/images/main/gradien2-11cf7509b67c58a39ca5600a206637cf.png";